import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProcessoQuestaoService } from '../services/processo-questao.service';

@Injectable({
  providedIn: 'root',
})
export class ProcessoQuestaoResolver implements Resolve<boolean> {
  constructor(private service: ProcessoQuestaoService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}
